<app-header></app-header>

<section id="casos-exito" class="bg-grey reset-section-pad2">

    <div class="container">

          <div class="row">
            <app-title-section
            [titleTxt]="titleTxt"
            ></app-title-section>   
         </div>


         <div class="row">
             <div class="col-lg-12 casos-exito-blq">

                <app-casos-exito-listing-block class="col-lg-4 col-md-6 col-sm-6 col-12 casos-exito-blq-inner"
                  *ngFor="let item of ordererCasoItems; index as i"
                  [casosExito_item]="item"
                ></app-casos-exito-listing-block>
                   
             </div>   

         </div><!-- fin  sala de prensa-->


     </div>

</section>

<app-footer-main></app-footer-main>
